import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ConfigContext from '../../../contexts/ConfigContext';

import Accordion from '../../shared/Accordion';
import AccordionItem from '../../shared/AccordionItem';
import accordionMenuTheme from '../../shared/Accordion-publicMenu.module.postcss';

import styles from './TruckMenu.module.postcss';

function TruckMenuItem({ item }) {
  const { imageBase } = useContext(ConfigContext);

  return (
    <div className={styles.TruckMenuItem}>
      <div className={styles.TruckMenuItem_content}>
        <div className='u-strong'>{item.name}</div>
        <p className='u-lightGrey u-mb05 u-mt05'>{item.description}</p>
        <div className='u-strong'>${item.price}</div>
      </div>
      { item.photo &&
        <img
          className={styles.TruckMenuItem_photo}
          src={`${imageBase}/${item.photo}`}
          alt={item.name}
          loading='lazy'
        />
      }
    </div>
  );
}

function TruckMenu({ menuItems }) {
  const appetizerItems = menuItems.filter((item) => item.category === 'appetizer');
  const entreeItems = menuItems.filter((item) => item.category === 'entree');
  const sideItems = menuItems.filter((item) => item.category === 'side');
  const drinkItems = menuItems.filter((item) => item.category === 'drink');
  const dessertItems = menuItems.filter((item) => item.category === 'dessert');
  const otherItems = menuItems.filter((item) => !item.category);

  const appetizerList = appetizerItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });
  const entreeList = entreeItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });
  const sideList = sideItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });
  const drinkList = drinkItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });
  const dessertList = dessertItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });
  const otherList = otherItems.map((item) => {
    return <TruckMenuItem item={item} key={item.id} />;
  });

  return (
    <Accordion theme={accordionMenuTheme}>
      { entreeList.length > 0 &&
        <AccordionItem title='Entrees'>{ entreeList }</AccordionItem>
      }
      { appetizerList.length > 0 &&
        <AccordionItem title='Appetizers'>{ appetizerList }</AccordionItem>
      }
      { sideList.length > 0 &&
        <AccordionItem title='Sides'>{ sideList }</AccordionItem>
      }
      { drinkList.length > 0 &&
        <AccordionItem title='Drinks'>{ drinkList }</AccordionItem>
      }
      { dessertList.length > 0 &&
        <AccordionItem title='Desserts'>{ dessertList }</AccordionItem>
      }
      { otherList.length > 0 &&
        <AccordionItem title='Other'>{ otherList }</AccordionItem>
      }
    </Accordion>
  );
}

TruckMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TruckMenu;
